export default {"src":"/_next/static/media/fullscreen.393cd8d4.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};